import React from "react";

import Grid from "@busbud/design-system-components/dist/Grid/Grid";

import { useAppContext } from "@app/helpers/hooks";

import { HepstarTermChip, NOT_COVERED } from "./hepstar-terms-chip";

export const HepstarTermsNotCoveredChips = () => {
  const { translator } = useAppContext();

  return (
    <Grid container xSpacing={6}>
      <Grid item xs={24} md={12}>
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.canceled-operator"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.covid-restriction"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.non-attendance"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.wish-no-longer-travel"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.fear-travelling"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.fail-law-comply"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.nature-disasters"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.hostilities-acts"
          )}
        />
      </Grid>
      <Grid item xs={24} md={12}>
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.deportation"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.poisonous-material"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.cyber-incidents"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.state-property-seizure"
          )}
        />
        <HepstarTermChip
          category={NOT_COVERED}
          label={translator.t(
            "!ancillary.hepstar.terms.not-covered.emanating-restrictions"
          )}
        />
      </Grid>
    </Grid>
  );
};
